import React, { useContext } from "react";
import dayjs from "dayjs";
import TrainerLayout from "./TrainerLayout";
import Tabs from "../commons/Tabs";
import { TrainerContext } from "../../context/TrainerContext";
import TrainerConfirmedTrainings from "./TrainerConfirmedTrainings";
import TrainerCanceledTrainings from "./TrainerCanceledTrainings";
import "../../styles/TrainerTrainings1.css";

/**
 * Main component for displaying trainer's training sessions
 * Provides tabs for viewing confirmed and canceled trainings
 */
const TrainerTrainings = () => {
    const { trainer } = useContext(TrainerContext);

    /**
     * Build endpoint URL for fetching confirmed trainings
     * @param {string} trainerId - The trainer's ID
     * @returns {string|null} API endpoint URL or null if trainerId is missing
     */
    const buildConfirmedTrainingsEndpoint = (trainerId) => {
        if (!trainerId) return null;

        const startTime = dayjs().format("YYYY-MM-DDTHH:mm:ss");
        const endTime = dayjs()
            .add(2, "month")
            .endOf("month")
            .format("YYYY-MM-DDTHH:mm:ss");

        return `/api/v1/training/getConfirmedTrainingsForTrainer/${trainerId}?startTime=${startTime}&endTime=${endTime}`;
    };

    /**
     * Build endpoint URL for fetching canceled trainings
     * @param {string} trainerId - The trainer's ID or 'school' for all trainers
     * @returns {string|null} API endpoint URL or null if required data is missing
     */
    const buildCanceledTrainingsEndpoint = (trainerId) => {
        if (!trainerId || !trainer?.schoolId) return null;

        const timeFrom = dayjs()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DDTHH:mm:ss");
        const timeTo = dayjs()
            .add(1, "month")
            .endOf("month")
            .format("YYYY-MM-DDTHH:mm:ss");

        if (trainerId === 'school') {
            return `/api/v1/archive/canceled-training/${trainer.schoolId}/school?timeFrom=${timeFrom}&timeTo=${timeTo}`;
        }

        return `/api/v1/archive/canceled-training/${trainerId}/trainer?timeFrom=${timeFrom}&timeTo=${timeTo}`;
    };

    // Configuration for the tabs component
    const tabsConfiguration = [
        {
            key: "confirmed",
            label: "Wkrótce",
            endpoint: buildConfirmedTrainingsEndpoint(trainer?.id),
            paginated: false,
            renderContent: (data) => <TrainerConfirmedTrainings data={data} />
        },
        {
            key: "canceled",
            label: "Anulowane",
            endpoint: buildCanceledTrainingsEndpoint(trainer?.id),
            paginated: false,
            renderContent: (data) => <TrainerCanceledTrainings data={data} />
        }
    ];

    return (
        <TrainerLayout>
            <div className="trainer-trainings-container">
                <div className="trainer-trainings-content">
                    <Tabs
                        tabs={tabsConfiguration}
                        activeId={trainer?.id}
                    />
                </div>
            </div>
        </TrainerLayout>
    );
};

export default TrainerTrainings;